import * as Contentful from "contentful";
import ContentfulContentService from "./ContentfulContentService";
import ContentService from "../ContentService";

export default class ContentfulContentServiceBuilder {
  //public environment = process.env.NODE_ENV === 'production' ? "master" : "stage";
  public environment = "master";
  // public environment = "stage";
  private host: string = "cdn.contentful.com";
  private spaceId: string;
  private accessToken: string;
  private locale: string = "en";

  constructor(spaceId: string, accessToken: string) {
    this.spaceId = spaceId;
    this.accessToken = accessToken;
  }

  public getHost(): string {
    return this.host;
  }

  public withHost(host: string): ContentfulContentServiceBuilder {
    this.host = host;
    return this;
  }

  public withLocale(locale: string): ContentfulContentServiceBuilder {
    this.locale = locale;
    return this;
  }

  public build(): ContentService {
    const client = Contentful.createClient({
      space: this.spaceId,
      accessToken: this.accessToken,
      host: this.host,
      environment: this.environment
    });
    return new ContentfulContentService(client, this.locale);
  }
}
